
import { lazy, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Desktop, DesktopComponentRegistry } from "../../common/components/Desktop";
import useClientConfig from "../../common/hooks/clientConfigHook";
import { now } from "../../common/utils/CDate";
import WeatherMap from "../WeatherMap";
import { StatsContext } from "./JobStatsContext";
import JobStatsMap from "./JobStatsMap";

const layouts = [
    {
        id: 0,
        title: '1 Column',
        defaultNarrow: true,
        columns: [
            { rows: [{ id: 1, components: ['jobStatsDisplayWarpper'], proportion: 90 }, { id: 'toolbar', components: ['toolbar'], proportion: 10, fixed: true }], proportion: 100, id: 1 }
        ]
    },
    {
        id: 1,
        title: '2 Column Left',
        narrow: false,
        defaultMedium: true,
        defaultWide: true,
        columns: [
            { rows: [{ id: 'left', components: ['jobStatsList'], proportion: 90 }, { id: 'toolbar', components: ['toolbar'], proportion: 10, fixed: true }], proportion: 25, id: 2 },
            { rows: [{ id: 'main', components: ['jobStatsDisplayWrapper'], proportion: 100 }], proportion: 75, id: 1 }
        ]
    },
    {
        id: 2,
        title: '2 Column Left - Detail',
        narrow: false,
        columns: [
            { rows: [{ id: 'left', components: ['jobStatsList'], proportion: 45 }, { id: 'bottomLeft', components: ['jobStatsMap', 'weatherMap'], proportion: 45 }, { id: 'toolbar', components: ['toolbar'], proportion: 10, fixed: true }], proportion: 25, id: 2 },
            { rows: [{ id: 'main', components: ['jobStatsDisplayWrapper'], proportion: 100 }], proportion: 75, id: 1 }
        ]
    },
    {
        id: 3,
        title: '2 Column Right',
        narrow: false,
        columns: [
            { rows: [{ id: 'main', components: ['jobStatsDisplayWrapper'], proportion: 100 }], proportion: 75, id: 1 },
            { rows: [{ id: 'right', components: ['jobStatsList'], proportion: 90 }, { id: 'toolbar', components: ['toolbar'], proportion: 10, fixed: true }], proportion: 25, id: 2 }
        ]
    },
    {
        id: 4,
        title: '2 Column Right - Detail',
        narrow: false,
        columns: [
            { rows: [{ id: 'main', components: ['jobStatsDisplayWrapper'], proportion: 100 }], proportion: 75, id: 1 },
            { rows: [{ id: 'right', components: ['jobStatsList'], proportion: 45 }, { id: 'bottomRight', components: ['jobStatsMap', 'weatherMap'], proportion: 45 }, { id: 'toolbar', components: ['toolbar'], proportion: 10, fixed: true }], proportion: 25, id: 2 }
        ]
    }
]

const JobStats = () => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const [search, setSearch] = useState({ start: now(clientConfig.tz).startOf('day').add(4, 'hour').toISOString(), end: now(clientConfig.tz).add(1, 'day').startOf('day').add(4, 'hour').toISOString() });
    const components = useMemo(() => {
        const registry = new DesktopComponentRegistry();
        registry.addList({ id: 1, title: t('tools'), icon: { variant: 'solid', kind: 'screwdriver-wrench' } })
        registry.register({ sid: 'jobStatsList', component: lazy(() => import('./JobStatsList')), label: t('jobList'), icon: { variant: 'solid', kind: 'table-list' }, primary: true, list: 1 });
        registry.register({ sid: 'jobStatsDisplayWrapper', component: lazy(async () => { const module = await import('./JobStatsPanel'); return { default: module.JobStatsComponent } }), label: t('stats'), icon: { variant: 'solid', kind: 'chart-simple' }, primary: true, list: 1 });
        if (clientConfig.enableMapping) {
            registry.register({ sid: 'jobStatsMap', component: JobStatsMap, label: t('map'), icon: { variant: 'solid', kind: 'map-location-dot' }, primary: true, list: 1 });
            registry.register({ sid: 'weatherMap', component: WeatherMap, label: t('weatherMap'), icon: { variant: 'solid', kind: 'cloud-sun' }, primary: true, singleton: true, list: 1 });
        }
        return registry;
    }, [clientConfig, t]);
    const context = useMemo(() => ({ search, setSearch }), [search]);

    return <div className="pt-2 h-100">
        <StatsContext.Provider value={context}>
            <Desktop id="jobStats" key="desktop" layouts={layouts} components={components}></Desktop>
        </StatsContext.Provider>
    </div>
}


export default JobStats;